import React, { useState, useContext } from 'react';
import { node, string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Button } from '@thd-olt-component-react/button';
import { QuickView } from '@thd-olt-component-react/quick-view';
import './QuickView.style.scss';

export const QuickViewWrapper = ({
  children,
  itemId
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [fetch, setFetch] = useState(false);
  const { channel } = useContext(ExperienceContext);
  const openQuickView = () => {
    setIsOpen(true);
  };
  const fetchData = () => {
    setFetch(true);
  };
  return (channel === 'desktop') ? (
    <QueryProvider>
      <div className="fbt-quick-view">
        <Button
          onClick={openQuickView}
          onMouseEnter={() => fetchData(true)}
          dark
          outline
          className="fbt-quick-view__bttn"
        >Quick View
        </Button>
        {children}
      </div>
      <QuickView
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        itemId={itemId}
        fetch={fetch}
      />
    </QueryProvider>
  ) : children;
};

QuickViewWrapper.propTypes = {
  children: node.isRequired,
  itemId: string.isRequired
};